export const SweetAlertActions = {
  confirm: 1,
  cancel: 2,
  backdrop: 3
}
